import { GEMATIK_ROOM } from './room.js';

/**
 * Message and event type constants used throughout the application.
 * These constants ensure consistency between hooks (useRoomList) and
 * display components (ConversationList).
 */
export const MESSAGE_TYPES = {
  // Custom event types from useRoomList
  MEMBERSHIP: 'membership',
  PROFILE_CHANGE: 'profile_change',

  // Matrix message types (m.room.message)
  TEXT: 'm.text',
  EMOTE: 'm.emote',
  NOTICE: 'm.notice',
  IMAGE: 'm.image',
  VIDEO: 'm.video',
  AUDIO: 'm.audio',
  FILE: 'm.file',

  // Matrix event types
  ROOM_MESSAGE: 'm.room.message',
  ROOM_MEMBER: 'm.room.member',
  ROOM_ENCRYPTED: 'm.room.encrypted',
  STICKER: 'm.sticker',
  REACTION: 'm.reaction',
};

// Supported Matrix message types for displayable timeline events
// Keep this in sync with all timeline/message filtering logic
export const SUPPORTED_MESSAGE_TYPES = [
  MESSAGE_TYPES.TEXT,
  MESSAGE_TYPES.IMAGE,
  MESSAGE_TYPES.VIDEO,
  MESSAGE_TYPES.AUDIO,
  MESSAGE_TYPES.FILE,
];

// List of Matrix event types that generate timeline system messages (e.g., join/leave, room name/topic changes)
// Used for grouping and filtering in timeline logic

export const TIMELINE_SYSTEM_EVENT_TYPES = [
  'm.room.member',
  'm.room.create',
  'm.room.name',
  'm.room.topic',
  GEMATIK_ROOM.ROOM_NAME,
  GEMATIK_ROOM.ROOM_TOPIC,  
  'm.room.avatar',
  'm.room.join_rules',
  'm.room.guest_access',
  'm.room.history_visibility',
  'm.room.power_levels',
  'm.room.canonical_alias',
  'm.room.pinned_events',
  'm.room.tombstone',
  'm.room.third_party_invite',
];


// Filter types for reaction details
export const REACTION_FILTER_TYPES = {
  ALL: 'all',
};

export const TIMESTAMP_THRESHOLDS = {
WEEK_MS: 604800000,
THREE_MONTHS_MS: 7776000000,
NINE_MONTHS_MS: 3 * 7776000000,
};
